import React, { useState } from 'react';
import './Common.css';
import { apiService } from '../api/api';
import { Check, Plus, Edit2, Trash2, MapPin, X } from 'lucide-react';

// ─── International Phone Validation ──────────────────────────────────────────
const COUNTRY_PHONE_RULES = [
  { code: '+1',   iso: 'US',  name: 'USA / Canada',maxLen: 12, pattern: /^\+1[2-9]\d{2}[2-9]\d{6}$/,               digits: '10 digits after +1',     example: '+12025551234' },
  { code: '+91',  iso: 'IN',  name: 'India',        maxLen: 13, pattern: /^\+91[6-9]\d{9}$/,                         digits: '10 digits after +91',    example: '+919876543210' },
  { code: '+86',  iso: 'CN',  name: 'China',        maxLen: 14, pattern: /^\+86(13|14|15|16|17|18|19)\d{9}$/,        digits: '11 digits after +86',    example: '+8613812345678' },
  { code: '+81',  iso: 'JP',  name: 'Japan',        maxLen: 13, pattern: /^\+81[789]0\d{8}$/,                        digits: '10-11 digits after +81', example: '+819012345678' },
  { code: '+82',  iso: 'KR',  name: 'South Korea',  maxLen: 13, pattern: /^\+821[0-9]\d{7,8}$/,                      digits: '9-10 digits after +82',  example: '+821012345678' },
  { code: '+65',  iso: 'SG',  name: 'Singapore',    maxLen: 11, pattern: /^\+65[689]\d{7}$/,                         digits: '8 digits after +65',     example: '+6591234567' },
  { code: '+60',  iso: 'MY',  name: 'Malaysia',     maxLen: 13, pattern: /^\+601[0-9]\d{7,8}$/,                      digits: '9-10 digits after +60',  example: '+60123456789' },
  { code: '+66',  iso: 'TH',  name: 'Thailand',     maxLen: 12, pattern: /^\+66[689]\d{8}$/,                         digits: '9 digits after +66',     example: '+66812345678' },
  { code: '+63',  iso: 'PH',  name: 'Philippines',  maxLen: 13, pattern: /^\+639\d{9}$/,                             digits: '10 digits after +63',    example: '+639171234567' },
  { code: '+62',  iso: 'ID',  name: 'Indonesia',    maxLen: 15, pattern: /^\+628\d{8,11}$/,                          digits: '9-12 digits after +62',  example: '+62812345678' },
  { code: '+92',  iso: 'PK',  name: 'Pakistan',     maxLen: 13, pattern: /^\+923\d{9}$/,                             digits: '10 digits after +92',    example: '+923001234567' },
  { code: '+880', iso: 'BD',  name: 'Bangladesh',   maxLen: 14, pattern: /^\+8801[3-9]\d{8}$/,                       digits: '10 digits after +880',   example: '+8801712345678' },
  { code: '+971', iso: 'AE',  name: 'UAE',          maxLen: 13, pattern: /^\+9715\d{8}$/,                            digits: '9 digits after +971',    example: '+971501234567' },
  { code: '+966', iso: 'SA',  name: 'Saudi Arabia', maxLen: 13, pattern: /^\+9665\d{8}$/,                            digits: '9 digits after +966',    example: '+966512345678' },
  { code: '+974', iso: 'QA',  name: 'Qatar',        maxLen: 12, pattern: /^\+974[3-7]\d{7}$/,                        digits: '8 digits after +974',    example: '+97430123456' },
  { code: '+973', iso: 'BH',  name: 'Bahrain',      maxLen: 12, pattern: /^\+973[3-9]\d{7}$/,                        digits: '8 digits after +973',    example: '+97333123456' },
  { code: '+968', iso: 'OM',  name: 'Oman',         maxLen: 12, pattern: /^\+9689\d{7}$/,                            digits: '8 digits after +968',    example: '+96891234567' },
  { code: '+972', iso: 'IL',  name: 'Israel',       maxLen: 13, pattern: /^\+9725\d{8}$/,                            digits: '9 digits after +972',    example: '+972501234567' },
  { code: '+44',  iso: 'GB',  name: 'UK',           maxLen: 13, pattern: /^\+447\d{9}$/,                             digits: '10 digits after +44',    example: '+447911123456' },
  { code: '+49',  iso: 'DE',  name: 'Germany',      maxLen: 15, pattern: /^\+491[567]\d{8,10}$/,                     digits: '10-12 digits after +49', example: '+4915123456789' },
  { code: '+33',  iso: 'FR',  name: 'France',       maxLen: 12, pattern: /^\+33[67]\d{8}$/,                          digits: '9 digits after +33',     example: '+33612345678' },
  { code: '+39',  iso: 'IT',  name: 'Italy',        maxLen: 13, pattern: /^\+393\d{9}$/,                             digits: '10 digits after +39',    example: '+393123456789' },
  { code: '+34',  iso: 'ES',  name: 'Spain',        maxLen: 12, pattern: /^\+346\d{8}$/,                             digits: '9 digits after +34',     example: '+34612345678' },
  { code: '+31',  iso: 'NL',  name: 'Netherlands',  maxLen: 12, pattern: /^\+316\d{8}$/,                             digits: '9 digits after +31',     example: '+31612345678' },
  { code: '+41',  iso: 'CH',  name: 'Switzerland',  maxLen: 12, pattern: /^\+417[6-9]\d{7}$/,                        digits: '9 digits after +41',     example: '+41761234567' },
  { code: '+43',  iso: 'AT',  name: 'Austria',      maxLen: 14, pattern: /^\+436\d{8,10}$/,                          digits: '9-11 digits after +43',  example: '+436641234567' },
  { code: '+32',  iso: 'BE',  name: 'Belgium',      maxLen: 12, pattern: /^\+324\d{8}$/,                             digits: '9 digits after +32',     example: '+32412345678' },
  { code: '+47',  iso: 'NO',  name: 'Norway',       maxLen: 11, pattern: /^\+474\d{7}$/,                             digits: '8 digits after +47',     example: '+4741234567' },
  { code: '+46',  iso: 'SE',  name: 'Sweden',       maxLen: 12, pattern: /^\+467\d{8}$/,                             digits: '9 digits after +46',     example: '+46701234567' },
  { code: '+45',  iso: 'DK',  name: 'Denmark',      maxLen: 11, pattern: /^\+454\d{7}$/,                             digits: '8 digits after +45',     example: '+4541234567' },
  { code: '+358', iso: 'FI',  name: 'Finland',      maxLen: 14, pattern: /^\+3584\d{7,8}$/,                          digits: '8-9 digits after +358',  example: '+358412345678' },
  { code: '+48',  iso: 'PL',  name: 'Poland',       maxLen: 12, pattern: /^\+48[4-9]\d{8}$/,                         digits: '9 digits after +48',     example: '+48512345678' },
  { code: '+7',   iso: 'RU',  name: 'Russia',       maxLen: 12, pattern: /^\+7[789]\d{9}$/,                          digits: '10 digits after +7',     example: '+79161234567' },
  { code: '+380', iso: 'UA',  name: 'Ukraine',      maxLen: 13, pattern: /^\+380[3-9]\d{8}$/,                        digits: '9 digits after +380',    example: '+380501234567' },
  { code: '+30',  iso: 'GR',  name: 'Greece',       maxLen: 13, pattern: /^\+306\d{9}$/,                             digits: '10 digits after +30',    example: '+306901234567' },
  { code: '+351', iso: 'PT',  name: 'Portugal',     maxLen: 13, pattern: /^\+3519\d{8}$/,                            digits: '9 digits after +351',    example: '+351912345678' },
  { code: '+36',  iso: 'HU',  name: 'Hungary',      maxLen: 13, pattern: /^\+36[237]\d{7,8}$/,                       digits: '8-9 digits after +36',   example: '+36201234567' },
  { code: '+420', iso: 'CZ',  name: 'Czech Republic', maxLen: 13, pattern: /^\+420[6-7]\d{8}$/,                      digits: '9 digits after +420',    example: '+420601234567' },
  { code: '+40',  iso: 'RO',  name: 'Romania',      maxLen: 12, pattern: /^\+407\d{8}$/,                             digits: '9 digits after +40',     example: '+40712345678' },
  { code: '+55',  iso: 'BR',  name: 'Brazil',       maxLen: 14, pattern: /^\+55[1-9][1-9]\d{8,9}$/,                  digits: '10-11 digits after +55', example: '+5511912345678' },
  { code: '+52',  iso: 'MX',  name: 'Mexico',       maxLen: 14, pattern: /^\+521\d{10}$/,                            digits: '10 digits after +52',    example: '+5215512345678' },
  { code: '+54',  iso: 'AR',  name: 'Argentina',    maxLen: 14, pattern: /^\+549\d{10}$/,                            digits: '10 digits after +54',    example: '+5491112345678' },
  { code: '+56',  iso: 'CL',  name: 'Chile',        maxLen: 12, pattern: /^\+569\d{8}$/,                             digits: '9 digits after +56',     example: '+56912345678' },
  { code: '+57',  iso: 'CO',  name: 'Colombia',     maxLen: 13, pattern: /^\+573\d{9}$/,                             digits: '10 digits after +57',    example: '+573001234567' },
  { code: '+27',  iso: 'ZA',  name: 'South Africa', maxLen: 12, pattern: /^\+276\d{8}$/,                             digits: '9 digits after +27',     example: '+27612345678' },
  { code: '+234', iso: 'NG',  name: 'Nigeria',      maxLen: 14, pattern: /^\+2347\d{9}$/,                            digits: '10 digits after +234',   example: '+2347012345678' },
  { code: '+20',  iso: 'EG',  name: 'Egypt',        maxLen: 13, pattern: /^\+201[0125]\d{8}$/,                       digits: '10 digits after +20',    example: '+201012345678' },
  { code: '+254', iso: 'KE',  name: 'Kenya',        maxLen: 13, pattern: /^\+2547\d{8}$/,                            digits: '9 digits after +254',    example: '+254712345678' },
  { code: '+61',  iso: 'AU',  name: 'Australia',    maxLen: 12, pattern: /^\+614\d{8}$/,                             digits: '9 digits after +61',     example: '+61412345678' },
  { code: '+64',  iso: 'NZ',  name: 'New Zealand',  maxLen: 13, pattern: /^\+642\d{7,9}$/,                           digits: '8-10 digits after +64',  example: '+6421234567' },
];
// ─── Practice Type Options ────────────────────────────────────────────────────
const PRACTICE_TYPES = [
  { id: 1, label: 'Spine Pain' },
  { id: 2, label: 'Primary Care' },
  { id: 3, label: 'Orthopedics' },
  { id: 4, label: 'Cardiology' },
  { id: 5, label: 'Dermatology' },
  { id: 6, label: 'Pediatrics' },
  { id: 7, label: 'Others' },
];

const detectCountryRule = (phone) => {
  if (!phone || !phone.startsWith('+')) return null;
  const sorted = [...COUNTRY_PHONE_RULES].sort((a, b) => b.code.length - a.code.length);
  return sorted.find(r => phone.startsWith(r.code)) || null;
};

const validatePhoneNumber = (phone) => {
  if (!phone || !phone.trim()) return { valid: false, message: 'Phone number is required' };
  const cleaned = phone.replace(/[\s\-().]/g, '');
  if (!cleaned.startsWith('+')) {
    return { valid: false, message: 'Phone must start with a country code (e.g. +1 for USA, +91 for India)' };
  }
  const rule = detectCountryRule(cleaned);
  if (!rule) {
    const genericPattern = /^\+\d{1,4}\d{6,12}$/;
    if (!genericPattern.test(cleaned)) {
      return { valid: false, message: 'Invalid phone number. Use format: +[country code][number]' };
    }
    return { valid: true, message: '', country: null };
  }
  if (!rule.pattern.test(cleaned)) {
    return { valid: false, message: `Invalid ${rule.name} number. Format: ${rule.digits} (e.g. ${rule.example})`, country: rule };
  }
  return { valid: true, message: '', country: rule };
};

// ─── SmartPhoneInput ──────────────────────────────────────────────────────────
const SmartPhoneInput = ({ value = '', onChange, onBlur, error, disabled = false, name = 'phoneNumber', placeholder, inputStyle = {} }) => {
  const cleaned   = value.replace(/[\s\-().]/g, '');
  const detected  = detectCountryRule(cleaned);
  const digitsTyped   = cleaned.replace(/^\+/, '').replace(/\D/g, '').length;
  const maxCleanLen   = detected ? detected.maxLen : null;
  const maxDigits     = maxCleanLen ? maxCleanLen - 1 : null;
  const isAtMax       = maxDigits !== null && digitsTyped >= maxDigits;
  const isOverMax     = maxDigits !== null && digitsTyped > maxDigits;
  const isValidNow    = detected && validatePhoneNumber(value).valid;
  const borderColor = error ? '#ea4335' : isOverMax ? '#ea4335' : isValidNow ? '#16a34a' : '#e0e0e0';
  const ALLOWED = /^[+\d\s\-().]*$/;
  const emit = (newVal) => { if (typeof onChange === 'function') onChange({ target: { name, value: newVal } }); };
  const handleKeyDown = (e) => {
    if (['Backspace','Delete','Tab','Enter','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(e.key) || e.ctrlKey || e.metaKey) return;
    if (e.key === '+') { if (e.target.selectionStart !== 0 || value.includes('+')) { e.preventDefault(); return; } }
    if (!/[\d\s\-().]/.test(e.key) && e.key !== '+') { e.preventDefault(); return; }
    if (/\d/.test(e.key) && maxDigits !== null) {
      const selectedDigits = value.slice(e.target.selectionStart, e.target.selectionEnd).replace(/\D/g, '').length;
      if (digitsTyped + 1 - selectedDigits > maxDigits) { e.preventDefault(); return; }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').replace(/[^+\d\s\-().]/g, '');
    const hasPlus = pasted.includes('+');
    pasted = pasted.replace(/\+/g, '');
    if (hasPlus) pasted = '+' + pasted;
    const { selectionStart: s, selectionEnd: en } = e.target;
    let newVal = value.slice(0, s) + pasted + value.slice(en);
    const newCleaned = newVal.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(newCleaned);
    if (rule) newVal = newCleaned.slice(0, rule.maxLen);
    emit(newVal);
  };
  const handleChange = (e) => {
    let val = e.target.value;
    if (!ALLOWED.test(val)) val = val.replace(/[^+\d\s\-().]/g, '');
    if (val.indexOf('+') > 0 || (val.split('+').length - 1) > 1) val = '+' + val.replace(/\+/g, '');
    const valCleaned = val.replace(/[\s\-().]/g, '');
    const rule = detectCountryRule(valCleaned);
    if (rule && valCleaned.length > rule.maxLen) val = valCleaned.slice(0, rule.maxLen);
    emit(val);
  };
  const counterText  = maxDigits !== null ? `${digitsTyped} / ${maxDigits}` : null;
  const counterColor = isOverMax ? '#ea4335' : isAtMax && isValidNow ? '#16a34a' : '#9ca3af';
  return (
    <div>
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {detected && (
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, display: 'flex', alignItems: 'center', gap: 4, padding: '0 10px', background: '#f1f5f9', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', borderRight: `1.5px solid ${borderColor}`, pointerEvents: 'none', zIndex: 2, whiteSpace: 'nowrap', minWidth: 58 }}>
            <span style={{ fontSize: 16, lineHeight: 1 }}>{detected.flag}</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#475569', letterSpacing: '0.5px' }}>{detected.iso}</span>
          </div>
        )}
        <input type="tel" name={name} value={value} onChange={handleChange} onKeyDown={handleKeyDown} onPaste={handlePaste} onBlur={onBlur} disabled={disabled} placeholder={placeholder || '+1 202 555 1234  ·  +91 98765 43210  ·  +44 7911 123456'}
          style={{ width: '100%', padding: `11px ${counterText ? '60px' : '14px'} 11px ${detected ? '70px' : '14px'}`, borderRadius: '8px', border: `1.5px solid ${borderColor}`, fontSize: '14px', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s', backgroundColor: disabled ? '#f8f9fa' : '#fff', color: disabled ? '#666' : '#1e293b', cursor: disabled ? 'not-allowed' : 'text', fontFamily: 'inherit', ...inputStyle }}
          onFocus={e => { if (!disabled) e.target.style.borderColor = error ? '#ea4335' : '#018d71'; }}
        />
        {counterText && !disabled && (
          <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 11, fontWeight: 700, color: counterColor, pointerEvents: 'none', userSelect: 'none' }}>{counterText}</span>
        )}
      </div>
      {!disabled && (() => {
        if (detected && isValidNow && !error) return (<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 5, fontSize: 11, color: '#16a34a', fontWeight: 600 }}><Check size={11} /> {detected.flag} {detected.name} · Valid number</div>);
        if (detected && isOverMax) return (<div style={{ marginTop: 5, fontSize: 11, color: '#ea4335', fontWeight: 600 }}>⚠️ Too many digits for {detected.name} ({detected.digits})</div>);
        if (detected && !isValidNow && !error && value.length > detected.code.length) return (<div style={{ marginTop: 5, fontSize: 11, color: '#6b7280' }}>{detected.flag} {detected.name} · {detected.digits} · e.g. {detected.example}</div>);
        if (!value) return (<div style={{ marginTop: 5, fontSize: 11, color: '#9ca3af' }}>Start with country code · +1 (USA) · +91 (India) · +44 (UK)</div>);
        return null;
      })()}
    </div>
  );
};

const SectionHeader = ({ number, title }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '28px 0 16px' }}>
    <div style={{ width: 28, height: 28, borderRadius: '50%', backgroundColor: '#018d71', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: 700, flexShrink: 0 }}>{number}</div>
    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#1e293b', borderBottom: '2px solid #e2e8f0', paddingBottom: '6px', flex: 1 }}>{title}</h3>
  </div>
);

const CheckboxGroup = ({ options, selected, onChange }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '6px' }}>
    {options.map(opt => {
      const isSelected = selected.includes(opt);
      return (
        <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '7px', cursor: 'pointer', padding: '7px 12px', borderRadius: '8px', border: `1.5px solid ${isSelected ? '#018d71' : '#e2e8f0'}`, backgroundColor: isSelected ? '#f0fdf9' : '#fff', fontSize: '13px', fontWeight: isSelected ? 600 : 400, color: isSelected ? '#018d71' : '#4b5563', transition: 'all 0.15s', userSelect: 'none' }}>
          <input type="checkbox" checked={isSelected} onChange={() => onChange(opt)} style={{ display: 'none' }} />
          <span style={{ width: 16, height: 16, borderRadius: '4px', border: `2px solid ${isSelected ? '#018d71' : '#d1d5db'}`, backgroundColor: isSelected ? '#018d71' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {isSelected && <Check size={10} color="#fff" strokeWidth={3} />}
          </span>
          {opt}
        </label>
      );
    })}
  </div>
);

const RadioGroup = ({ options, selected, onChange }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '6px' }}>
    {options.map(opt => {
      const isSelected = selected === opt;
      return (
        <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '7px', cursor: 'pointer', padding: '7px 14px', borderRadius: '8px', border: `1.5px solid ${isSelected ? '#018d71' : '#e2e8f0'}`, backgroundColor: isSelected ? '#f0fdf9' : '#fff', fontSize: '13px', fontWeight: isSelected ? 600 : 400, color: isSelected ? '#018d71' : '#4b5563', transition: 'all 0.15s', userSelect: 'none' }}>
          <input type="radio" checked={isSelected} onChange={() => onChange(opt)} style={{ display: 'none' }} />
          <span style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${isSelected ? '#018d71' : '#d1d5db'}`, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {isSelected && <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#018d71' }} />}
          </span>
          {opt}
        </label>
      );
    })}
  </div>
);

const fieldStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '8px',
  border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none',
  boxSizing: 'border-box', fontFamily: 'inherit', color: '#1e293b',
  transition: 'border-color 0.2s',
};
const labelStyle = {
  display: 'block', fontSize: '13px', fontWeight: 600,
  color: '#374151', marginBottom: '6px',
};

// ─── Address Form ─────────────────────────────────────────────────────────────
const AddressForm = ({ initial, onSave, onCancel, forceType }) => {
  const d = initial || {};
  const [form, setForm] = useState({
    fullName: d.fullName || '',
    mobileNo: d.mobileNo || '',
    alternateMobileNo: d.alternateMobileNo || '',
    email: d.email || '',
    addressLine1: d.addressLine1 || '',
    addressLine2: d.addressLine2 || '',
    landmark: d.landmark || '',
    city: d.city || '',
    state: d.state || '',
    country: 'USA',
    pincode: d.pincode || '',
    isDefault: forceType === 'both' ? true : (d.isDefault || false),
    isBilling: forceType === 'billing' || forceType === 'both' ? true : (d.isBilling || false),
    isShipping: forceType === 'shipping' || forceType === 'both' ? true : (d.isShipping || false),
  });
  const [errors, setErrors] = useState({});

  const set = (f, v) => { setForm(p => ({ ...p, [f]: v })); if (errors[f]) setErrors(p => ({ ...p, [f]: '' })); };
  const toggle = (k) => {
    if (forceType === 'both') return;
    if (forceType === 'shipping' && k === 'isShipping') return;
    if (forceType === 'billing'  && k === 'isBilling')  return;
    setForm(p => ({ ...p, [k]: !p[k] }));
    setErrors(p => ({ ...p, addressType: '' }));
  };

  const validate = () => {
    const e = {};
    if (!form.isDefault && !form.isBilling && !form.isShipping) e.addressType = 'Please select at least one address type';
    if (!form.fullName.trim()) e.fullName = 'Full name is required';
    else if (form.fullName.trim().length < 2) e.fullName = 'Full name must be at least 2 characters';
    else if (!/^[a-zA-Z\s'-]+$/.test(form.fullName.trim())) e.fullName = 'Full name can only contain letters, spaces, hyphens, and apostrophes';
    if (!form.mobileNo.trim()) e.mobileNo = 'Mobile number is required';
    else { const r = validatePhoneNumber(form.mobileNo.trim()); if (!r.valid) e.mobileNo = r.message; }
    if (form.alternateMobileNo.trim()) { const r = validatePhoneNumber(form.alternateMobileNo.trim()); if (!r.valid) e.alternateMobileNo = r.message; }
    if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = 'Please enter a valid email address';
    if (!form.addressLine1.trim()) e.addressLine1 = 'Address Line 1 is required';
    if (!form.city.trim()) e.city = 'City is required';
    if (!form.state.trim()) e.state = 'State / Province is required';
    if (!form.pincode.trim()) e.pincode = 'Pincode / ZIP code is required';
    else if (!/^\d{3,10}$/.test(form.pincode.trim())) e.pincode = 'Pincode must be 3–10 digits';
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    onSave(form);
  };

  const inp = (err) => ({
    width: '100%', padding: '12px 14px', borderRadius: '8px',
    border: `1.5px solid ${err ? '#ea4335' : '#e0e0e0'}`, fontSize: '14px',
    outline: 'none', boxSizing: 'border-box', transition: 'all 0.2s', backgroundColor: '#fff',
    fontFamily: 'inherit', color: '#1e293b',
  });
  const Lbl = ({ t, r }) => (
    <label style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '8px', display: 'block' }}>
      {t}{r && <span style={{ color: '#ea4335', marginLeft: 3 }}>*</span>}
    </label>
  );
  const Err = ({ m }) => m ? <div style={{ fontSize: '12px', color: '#ea4335', marginTop: '6px', fontWeight: 500 }}>⚠️ {m}</div> : null;

  const addrTypeLocked = (key) => {
    if (forceType === 'both') return true;
    if (forceType === 'shipping' && key === 'isShipping') return true;
    if (forceType === 'billing'  && key === 'isBilling')  return true;
    return false;
  };

  return (
    <div>
      {/* ── Info banner shown only inside the billing popup ─────────────────── */}
      {forceType === 'billing' && (
        <div style={{ marginBottom: '20px', padding: '12px 16px', backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: '10px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <span style={{ fontSize: '18px', lineHeight: 1, flexShrink: 0 }}>💡</span>
          <div style={{ fontSize: '13px', color: '#92400e', lineHeight: 1.6 }}>
            Saving this billing address will <strong>automatically switch</strong> the address preference to{' '}
            <em>"Same address for shipping &amp; billing"</em>.
          </div>
        </div>
      )}

      {/* Address Type */}
      <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: `1px solid ${errors.addressType ? '#fca5a5' : '#e9ecef'}` }}>
        <Lbl t="Address Type(s)" r />
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {[['isDefault', '🏠 Default'], ['isShipping', '📦 Shipping'], ['isBilling', '💳 Billing']].map(([k, l]) => {
            const active = form[k];
            const locked = addrTypeLocked(k);
            return (
              <label key={k} onClick={() => !locked && toggle(k)}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: locked ? 'default' : 'pointer', padding: '10px 16px', borderRadius: '8px', border: `2px solid ${active ? '#018d71' : '#ddd'}`, backgroundColor: active ? '#f0faf6' : '#fff', transition: 'all 0.2s', userSelect: 'none', opacity: locked ? 0.85 : 1 }}>
                <div style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${active ? '#018d71' : '#d1d5db'}`, background: active ? '#018d71' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {active && <Check size={11} color="white" strokeWidth={3} />}
                </div>
                <span style={{ fontSize: '14px', fontWeight: active ? 600 : 500, color: active ? '#018d71' : '#555' }}>{l}</span>
                {locked && <span style={{ fontSize: '10px', color: '#9ca3af', fontStyle: 'italic' }}>(auto)</span>}
              </label>
            );
          })}
        </div>
        <Err m={errors.addressType} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Full Name" r />
        <input type="text" value={form.fullName} onChange={e => set('fullName', e.target.value)} placeholder="John Doe" style={inp(errors.fullName)}
          onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = errors.fullName ? '#ea4335' : '#e0e0e0'} />
        <Err m={errors.fullName} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Email" />
        <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="john@example.com" style={inp(errors.email)}
          onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = errors.email ? '#ea4335' : '#e0e0e0'} />
        <Err m={errors.email} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Mobile Number" r />
        <SmartPhoneInput value={form.mobileNo} onChange={e => set('mobileNo', e.target.value)}
          onBlur={() => { if (form.mobileNo.trim()) { const r = validatePhoneNumber(form.mobileNo.trim()); if (!r.valid) setErrors(p => ({ ...p, mobileNo: r.message })); } }}
          error={errors.mobileNo} name="mobileNo" />
        <Err m={errors.mobileNo} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Alternate Mobile" />
        <SmartPhoneInput value={form.alternateMobileNo} onChange={e => set('alternateMobileNo', e.target.value)}
          onBlur={() => { if (form.alternateMobileNo.trim()) { const r = validatePhoneNumber(form.alternateMobileNo.trim()); if (!r.valid) setErrors(p => ({ ...p, alternateMobileNo: r.message })); else setErrors(p => ({ ...p, alternateMobileNo: '' })); } }}
          error={errors.alternateMobileNo} placeholder="+1 234 567 8900  (optional)" name="alternateMobileNo" />
        <Err m={errors.alternateMobileNo} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Address Line 1" r />
        <input type="text" value={form.addressLine1} onChange={e => set('addressLine1', e.target.value)} placeholder="Street address, P.O. box" style={inp(errors.addressLine1)}
          onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = errors.addressLine1 ? '#ea4335' : '#e0e0e0'} />
        <Err m={errors.addressLine1} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Address Line 2" />
        <input type="text" value={form.addressLine2} onChange={e => set('addressLine2', e.target.value)} placeholder="Apartment, suite, unit (optional)" style={inp(false)}
          onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = '#e0e0e0'} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <Lbl t="Landmark" />
        <input type="text" value={form.landmark} onChange={e => set('landmark', e.target.value)} placeholder="Near..., Opposite..." style={inp(false)}
          onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = '#e0e0e0'} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        {[['city', 'City', 'New York'], ['state', 'State / Province', 'NY']].map(([f, l, ph]) => (
          <div key={f}>
            <Lbl t={l} r />
            <input type="text" value={form[f]} onChange={e => set(f, e.target.value)} placeholder={ph} style={inp(errors[f])}
              onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = errors[f] ? '#ea4335' : '#e0e0e0'} />
            <Err m={errors[f]} />
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
        <div>
          <Lbl t="Pincode / ZIP" r />
          <input type="text" value={form.pincode} onChange={e => set('pincode', e.target.value.replace(/\D/g, ''))} placeholder="10001" style={inp(errors.pincode)}
            onFocus={e => e.target.style.borderColor = '#018d71'} onBlur={e => e.target.style.borderColor = errors.pincode ? '#ea4335' : '#e0e0e0'} maxLength={10} inputMode="numeric" />
          <Err m={errors.pincode} />
        </div>
        <div>
          <Lbl t="Country" r />
          <input type="text" value="USA" readOnly style={{ ...inp(false), backgroundColor: '#f8f9fa', color: '#666', cursor: 'not-allowed' }} />
        </div>
      </div>

      {Object.keys(errors).some(k => errors[k]) && (
        <div style={{ marginBottom: '20px', padding: '14px 18px', backgroundColor: '#fff8f8', border: '1.5px solid #fca5a5', borderRadius: '10px' }}>
          <div style={{ fontSize: '13px', fontWeight: 700, color: '#dc2626', marginBottom: '8px' }}>🚫 Please fix the following before saving:</div>
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            {Object.entries(errors).filter(([, v]) => v).map(([k, m]) => <li key={k} style={{ fontSize: '13px', color: '#b91c1c', marginBottom: '4px' }}>{m}</li>)}
          </ul>
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', paddingTop: '16px', borderTop: '1px solid #e9ecef' }}>
        <button type="button" onClick={onCancel}
          style={{ padding: '12px 24px', fontSize: '14px', fontWeight: 600, borderRadius: '8px', backgroundColor: '#fff', color: '#333', border: '1.5px solid #ddd', cursor: 'pointer' }}>
          Cancel
        </button>
        <button type="button" onClick={handleSubmit}
          style={{ padding: '12px 32px', fontSize: '14px', fontWeight: 600, borderRadius: '8px', background: 'linear-gradient(135deg, #018d71 0%, #1557b0 100%)', color: '#fff', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Check size={16} />Save Address
        </button>
      </div>
    </div>
  );
};

// ─── Address Modal Popup ──────────────────────────────────────────────────────
const AddressModal = ({ open, title, initial, forceType, onSave, onClose }) => {
  if (!open) return null;
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.52)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '620px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 28px', borderBottom: '1.5px solid #e9ecef', position: 'sticky', top: 0, background: '#fff', zIndex: 1, borderRadius: '16px 16px 0 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: 36, height: 36, borderRadius: '50%', backgroundColor: '#f0fdf9', border: '2px solid #018d71', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MapPin size={16} color="#018d71" />
            </div>
            <h3 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#1e293b' }}>{title}</h3>
          </div>
          <button type="button" onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', borderRadius: '8px', display: 'flex', alignItems: 'center', color: '#6b7280' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}>
            <X size={22} />
          </button>
        </div>
        <div style={{ padding: '24px 28px' }}>
          <AddressForm initial={initial} onSave={onSave} onCancel={onClose} forceType={forceType} />
        </div>
      </div>
    </div>
  );
};

// ─── Address Preview Card ─────────────────────────────────────────────────────
const AddressPreviewCard = ({ label, icon, address, onEdit, onRemove }) => {
  const lines = [
    address.fullName,
    address.mobileNo,
    address.addressLine1,
    address.addressLine2,
    address.landmark ? `Near: ${address.landmark}` : null,
    `${address.city}, ${address.state} ${address.pincode}`,
    address.country,
  ].filter(Boolean);
  return (
    <div style={{ border: '1.5px solid #018d71', borderRadius: '12px', padding: '16px 20px', backgroundColor: '#f0fdf9', position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
        <span style={{ fontSize: '18px' }}>{icon}</span>
        <span style={{ fontSize: '13px', fontWeight: 700, color: '#018d71', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</span>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
          <button type="button" onClick={onEdit}
            style={{ background: 'none', border: '1px solid #018d71', borderRadius: '6px', padding: '4px 10px', fontSize: '12px', fontWeight: 600, color: '#018d71', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Edit2 size={11} /> Edit
          </button>
          <button type="button" onClick={onRemove}
            style={{ background: 'none', border: '1px solid #ea4335', borderRadius: '6px', padding: '4px 10px', fontSize: '12px', fontWeight: 600, color: '#ea4335', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Trash2 size={11} /> Remove
          </button>
        </span>
      </div>
      <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.7' }}>
        {lines.map((l, i) => <div key={i}>{l}</div>)}
      </div>
    </div>
  );
};

// ─── Address Section ──────────────────────────────────────────────────────────
const AddressSection = ({ shippingAddress, billingAddress, sameAddress, onSameAddressChange, onShippingChange, onBillingChange }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTarget, setModalTarget] = useState(null);
  const [editingData, setEditingData] = useState(null);

  const openAdd  = (target) => { setEditingData(null); setModalTarget(target); setModalOpen(true); };
  const openEdit = (target, data) => { setEditingData(data); setModalTarget(target); setModalOpen(true); };

  // ── KEY CHANGE ────────────────────────────────────────────────────────────
  // When user saves a billing address (in "Different addresses" mode),
  // automatically switch the parent to "Same address" mode.
  // The billing address data is stored as the shared shipping+billing address.
  const handleSave = (formData) => {
    if (modalTarget === 'both') {
      onShippingChange({ ...formData, isShipping: true, isBilling: true, isDefault: true });
      onBillingChange(null);
    } else if (modalTarget === 'shipping') {
      onShippingChange({ ...formData, isShipping: true });
    } else if (modalTarget === 'billing') {
      // ✅ Auto-switch: treat billing address as the combined address
      //    and flip the toggle to "Same address" automatically
      onShippingChange({ ...formData, isShipping: true, isBilling: true, isDefault: true });
      onBillingChange(null);
      onSameAddressChange(true);   // ← flips the radio to "Same address"
    }
    setModalOpen(false);
    setEditingData(null);
  };
  // ─────────────────────────────────────────────────────────────────────────

  const handleToggleSame = (newVal) => {
    onSameAddressChange(newVal);
    if (newVal) onBillingChange(null);
  };

  const modalTitle = modalTarget === 'both'
    ? 'Add Shipping & Billing Address'
    : modalTarget === 'shipping'
      ? 'Add Shipping Address'
      : 'Add Billing Address';

  const getForceType = () => {
    if (modalTarget === 'both')     return 'both';
    if (modalTarget === 'shipping') return 'shipping';
    if (modalTarget === 'billing')  return 'billing';
    return null;
  };

  return (
    <>
      <AddressModal
        open={modalOpen}
        title={editingData
          ? `Edit ${modalTarget === 'both' ? 'Address' : modalTarget === 'shipping' ? 'Shipping Address' : 'Billing Address'}`
          : modalTitle}
        initial={editingData}
        forceType={getForceType()}
        onSave={handleSave}
        onClose={() => { setModalOpen(false); setEditingData(null); }}
      />

      {/* Same / Different Toggle */}
      <div style={{ marginBottom: '20px', padding: '14px 18px', backgroundColor: '#f8fafc', borderRadius: '10px', border: '1.5px solid #e2e8f0' }}>
        <div style={{ fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '12px' }}>
          Address preference:
        </div>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {[
            { val: true,  label: '✅ Same address for shipping & billing' },
            { val: false, label: '📦💳 Different addresses for shipping & billing' },
          ].map(opt => {
            const active = sameAddress === opt.val;
            return (
              <label key={String(opt.val)}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '9px 16px', borderRadius: '8px', border: `1.5px solid ${active ? '#018d71' : '#e2e8f0'}`, backgroundColor: active ? '#f0fdf9' : '#fff', fontSize: '13px', fontWeight: active ? 600 : 400, color: active ? '#018d71' : '#4b5563', transition: 'all 0.15s', userSelect: 'none' }}>
                <input type="radio" checked={active} onChange={() => handleToggleSame(opt.val)} style={{ display: 'none' }} />
                <span style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${active ? '#018d71' : '#d1d5db'}`, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {active && <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#018d71' }} />}
                </span>
                {opt.label}
              </label>
            );
          })}
        </div>
      </div>

      {/* Same address mode */}
      {sameAddress && (
        <div>
          {shippingAddress ? (
            <AddressPreviewCard
              label="Shipping & Billing Address" icon="🏠"
              address={shippingAddress}
              onEdit={() => openEdit('both', shippingAddress)}
              onRemove={() => { onShippingChange(null); onBillingChange(null); }}
            />
          ) : (
            <button type="button" onClick={() => openAdd('both')}
              style={{ width: '100%', padding: '18px', borderRadius: '10px', border: '2px dashed #018d71', backgroundColor: '#f0fdf9', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontSize: '14px', fontWeight: 600, color: '#018d71', transition: 'all 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dcfce7'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0fdf9'}>
              <Plus size={18} /> Add Address (Shipping &amp; Billing)
            </button>
          )}
        </div>
      )}

      {/* Different addresses mode */}
      {!sameAddress && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {/* Shipping */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>📦</span> Shipping Address <span style={{ color: '#e74c3c' }}>*</span>
            </div>
            {shippingAddress ? (
              <AddressPreviewCard
                label="Shipping Address" icon="📦"
                address={shippingAddress}
                onEdit={() => openEdit('shipping', shippingAddress)}
                onRemove={() => onShippingChange(null)}
              />
            ) : (
              <button type="button" onClick={() => openAdd('shipping')}
                style={{ width: '100%', padding: '16px', borderRadius: '10px', border: '2px dashed #34a853', backgroundColor: '#f0fdf4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontSize: '14px', fontWeight: 600, color: '#15803d', transition: 'all 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dcfce7'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0fdf4'}>
                <Plus size={18} /> Add Shipping Address
              </button>
            )}
          </div>

          {/* Billing */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>💳</span> Billing Address <span style={{ color: '#e74c3c' }}>*</span>
            </div>
            {billingAddress ? (
              <AddressPreviewCard
                label="Billing Address" icon="💳"
                address={billingAddress}
                onEdit={() => openEdit('billing', billingAddress)}
                onRemove={() => onBillingChange(null)}
              />
            ) : (
              <button type="button" onClick={() => openAdd('billing')}
                style={{ width: '100%', padding: '16px', borderRadius: '10px', border: '2px dashed #ea4335', backgroundColor: '#fff5f5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontSize: '14px', fontWeight: 600, color: '#dc2626', transition: 'all 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#fee2e2'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff5f5'}>
                <Plus size={18} /> Add Billing Address
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// ─── Questionnaire Form ────────────────────────────────────────────────────────
const QuestionnaireForm = ({ registeredEmail, onDone }) => {
const [q, setQ] = useState({
    clinicName: '', practiceType: '', npiLicense: '',
    contactName: '', contactPhone: '', contactEmail: registeredEmail || '',
    sameAddress: true, shippingAddress: null, billingAddress: null,
    products: [], otherProduct: '', monthlySpend: '',
    paymentMethods: [], validLicense: '',
    licenseType: '',        // ← NEW: 'DEA' or 'Medical'
    licenseNumber: '',      // ← NEW: replaces deaNumber
    licenseExpiryDate: '',  // ← NEW
    authorizedSign: '',     // ← NEW
    orderMethods: [], notes: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors]         = useState({});

  const setField = (field, value) => setQ(prev => ({ ...prev, [field]: value }));
  const toggleCheckbox = (field, value) => {
    setQ(prev => {
      const arr = prev[field];
      return { ...prev, [field]: arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value] };
    });
  };

  const validate = () => {
    const e = {};
    if (!q.clinicName.trim())     e.clinicName     = 'Clinic name is required';
    if (!q.practiceType)          e.practiceType   = 'Practice type is required';
    if (!q.contactName.trim())    e.contactName    = 'Contact name is required';
    if (!q.shippingAddress)       e.address        = q.sameAddress ? 'Please add an address' : 'Please add a shipping address';
    if (!q.sameAddress && !q.billingAddress) e.billingAddress = 'Please add a billing address';
    if (!q.products.length)       e.products       = 'Please select at least one product';
    if (!q.monthlySpend)          e.monthlySpend   = 'Please select estimated monthly spend';
    if (!q.paymentMethods.length) e.paymentMethods = 'Please select a payment method';
    if (!q.validLicense)          e.validLicense   = 'Please confirm your medical license status';
    if (!q.orderMethods.length)   e.orderMethods   = 'Please select a preferred order method';
    return e;
  };
const handleSubmit = async () => {
  const errs = validate();
  if (Object.keys(errs).length > 0) { setErrors(errs); return; }
  setSubmitting(true);
  try {
    // ── 1. Save shipping address (always required) ───────────────────
    if (q.shippingAddress) {
      await apiService.createAddress({
        ...q.shippingAddress,
        isShipping: true,
        isBilling:  q.sameAddress,
        isDefault:  q.sameAddress,
      });
    }

    // ── 2. Save separate billing address (only in "different" mode) ──
    if (!q.sameAddress && q.billingAddress) {
      await apiService.createAddress({
        ...q.billingAddress,
        isBilling:  true,
        isShipping: false,
        isDefault:  false,
      });
    }

    // ── 3. Create Clinic ─────────────────────────────────────────────
    const clinicResponse = await apiService.createClinic({
      clinicName:             q.clinicName,
      practiceType:           parseInt(q.practiceType) || 0,                            // free-text → default 0; extend mapping if API adds enum
      monthlySpend:           q.monthlySpend,
      paymentMethod:          q.paymentMethods.join(', '),
      hasValidMedicalLicense: q.validLicense === 'Yes',
      npi:                    q.npiLicense,
      preferredOrderMethod:   q.orderMethods.join(', '),
      notes:                  q.notes,
    });

    // Extract clinicId from response (handle various shapes)
    const clinicId =
      clinicResponse?.clinicId   ??
      clinicResponse?.id         ??
      clinicResponse?.data?.clinicId ??
      clinicResponse?.data?.id   ??
      0;

    console.log('✅ Clinic created, clinicId:', clinicId);

    // ── 4. Save Clinic License (only if user selected a license type) ─
    if (q.licenseType && clinicId) {
      const licensePayload = [
        {
          licenseTypeId:    q.licenseType === 'DEA' ? 1 : 2,
          clinicLicenseId:  0,
          clinicId:         parseInt(clinicId) || 0,
          licenseNumber:    q.licenseNumber    || '',
          expiryDate:       q.licenseExpiryDate
                              ? q.licenseExpiryDate          // already "YYYY-MM-DD" from date input
                              : new Date().toISOString().split('T')[0],
          authorizedSign:   q.authorizedSign   || '',
        },
      ];
      await apiService.createClinicLicense(licensePayload);
      console.log('✅ ClinicLicense saved, type:', q.licenseType, '(id:', q.licenseType === 'DEA' ? 1 : 2, ')');
    }

    onDone();
  } catch (err) {
    console.error('❌ Questionnaire submit failed:', err);
    setErrors({ submit: 'Failed to submit. Please try again.' });
  } finally {
    setSubmitting(false);
  }
};

  const inputFocus = e => (e.target.style.borderColor = '#018d71');
  const inputBlur  = e => (e.target.style.borderColor = '#e0e0e0');

  return (
    <div className="login-page" style={{ minHeight: '100vh', padding: '20px 0' }}>
      <div className="login-container" style={{ maxWidth: '800px' }}>
        <div className="login-card" style={{ padding: '32px 36px' }}>
          <div style={{ textAlign: 'center', marginBottom: '8px' }}>
            <div style={{ width: 52, height: 52, borderRadius: '50%', backgroundColor: '#f0fdf9', border: '2px solid #018d71', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', fontSize: '22px' }}>📋</div>
            <h1 style={{ margin: '0 0 6px', fontSize: '22px', fontWeight: 700, color: '#1e293b' }}>Sign-Up Questionnaire</h1>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>Please complete the form below to finish your registration.</p>
          </div>
          <div style={{ margin: '20px 0', height: '4px', backgroundColor: '#e2e8f0', borderRadius: '2px' }}>
            <div style={{ height: '100%', width: '100%', backgroundColor: '#018d71', borderRadius: '2px' }} />
          </div>
          {errors.submit && (
            <div style={{ padding: '10px 14px', backgroundColor: '#fff5f5', border: '1px solid #fca5a5', borderRadius: '8px', color: '#dc2626', fontSize: '13px', marginBottom: '16px' }}>⚠️ {errors.submit}</div>
          )}

          <SectionHeader number={1} title="Clinic Info" />
          <div className="form-group">
            <label style={labelStyle}>Clinic Name <span style={{ color: '#e74c3c' }}>*</span></label>
            <input style={fieldStyle} placeholder="e.g. Sunrise Medical Clinic" value={q.clinicName} onChange={e => setField('clinicName', e.target.value)} onFocus={inputFocus} onBlur={inputBlur} />
            {errors.clinicName && <span className="error-message">{errors.clinicName}</span>}
          </div>
<div className="form-group">
            <label style={labelStyle}>Practice Type <span style={{ color: '#e74c3c' }}>*</span></label>
            <select
              style={{
                ...fieldStyle,
                backgroundColor: q.practiceType ? '#fff' : '#fff',
                color: q.practiceType ? '#1e293b' : '#9ca3af',
                cursor: 'pointer',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 14px center',
                paddingRight: '36px',
                border: `1.5px solid ${errors.practiceType ? '#ea4335' : '#e0e0e0'}`,
              }}
              value={q.practiceType}
              onChange={e => {
                setField('practiceType', e.target.value);
                if (errors.practiceType) setErrors(prev => ({ ...prev, practiceType: '' }));
              }}
              onFocus={inputFocus}
              onBlur={inputBlur}
            >
              <option value="">Select practice type</option>
              {PRACTICE_TYPES.map(pt => (
                <option key={pt.id} value={pt.id}>{pt.label}</option>
              ))}
            </select>
            {errors.practiceType && <span className="error-message">{errors.practiceType}</span>}
          </div>
          <div className="form-group">
            <label style={labelStyle}>NPI or License #</label>
            <input style={fieldStyle} placeholder="Enter NPI or License number" value={q.npiLicense} onChange={e => setField('npiLicense', e.target.value)} onFocus={inputFocus} onBlur={inputBlur} />
          </div>

          <SectionHeader number={2} title="Contact Details" />
          <div className="form-group">
            <label style={labelStyle}>Contact Name <span style={{ color: '#e74c3c' }}>*</span></label>
            <input style={fieldStyle} placeholder="Full name of primary contact" value={q.contactName} onChange={e => setField('contactName', e.target.value)} onFocus={inputFocus} onBlur={inputBlur} />
            {errors.contactName && <span className="error-message">{errors.contactName}</span>}
          </div>
          <div className="form-group">
            <label style={labelStyle}>Phone</label>
            <SmartPhoneInput value={q.contactPhone} onChange={e => setField('contactPhone', e.target.value)} name="contactPhone" />
          </div>
          <div className="form-group">
            <label style={labelStyle}>Email</label>
            <input type="email" style={{ ...fieldStyle, backgroundColor: '#f8f9fa', color: '#666', cursor: 'not-allowed' }} value={q.contactEmail} readOnly />
            <span style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px', display: 'block' }}>Pre-filled from your registration</span>
          </div>

          <SectionHeader number={3} title="Address" />
          <AddressSection
            shippingAddress={q.shippingAddress}
            billingAddress={q.billingAddress}
            sameAddress={q.sameAddress}
            onSameAddressChange={val => setField('sameAddress', val)}
            onShippingChange={val => setField('shippingAddress', val)}
            onBillingChange={val => setField('billingAddress', val)}
          />
          {(errors.address || errors.billingAddress) && (
            <div style={{ marginTop: '10px' }}>
              {errors.address && <div style={{ fontSize: '12px', color: '#dc2626', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '4px' }}>⚠️ {errors.address}</div>}
              {errors.billingAddress && <div style={{ fontSize: '12px', color: '#dc2626', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '5px' }}>⚠️ {errors.billingAddress}</div>}
            </div>
          )}

          <SectionHeader number={4} title="What Do You Need?" />
          <div className="form-group">
            <label style={labelStyle}>Main Products <span style={{ color: '#e74c3c' }}>*</span> <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af' }}>(select all that apply)</span></label>
            <CheckboxGroup options={['Gloves', 'Syringes / Needles', 'IV Supplies', 'Medications', 'Surgical Supplies', 'Other']} selected={q.products} onChange={v => toggleCheckbox('products', v)} />
            {q.products.includes('Other') && <input style={{ ...fieldStyle, marginTop: '10px' }} placeholder="Please specify other product" value={q.otherProduct} onChange={e => setField('otherProduct', e.target.value)} onFocus={inputFocus} onBlur={inputBlur} />}
            {errors.products && <span className="error-message" style={{ marginTop: '6px', display: 'block' }}>{errors.products}</span>}
          </div>
          <div className="form-group">
            <label style={labelStyle}>Estimated Monthly Spend <span style={{ color: '#e74c3c' }}>*</span></label>
            <RadioGroup options={['Less than $1K', '$1K – $5K', '$5K+']} selected={q.monthlySpend} onChange={v => setField('monthlySpend', v)} />
            {errors.monthlySpend && <span className="error-message" style={{ marginTop: '6px', display: 'block' }}>{errors.monthlySpend}</span>}
          </div>

          <SectionHeader number={5} title="Payment" />
          <div className="form-group">
            <label style={labelStyle}>Payment Method <span style={{ color: '#e74c3c' }}>*</span> <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af' }}>(select all that apply)</span></label>
            <CheckboxGroup options={['Card', 'ACH', 'Net Terms (Apply)']} selected={q.paymentMethods} onChange={v => toggleCheckbox('paymentMethods', v)} />
            {errors.paymentMethods && <span className="error-message" style={{ marginTop: '6px', display: 'block' }}>{errors.paymentMethods}</span>}
          </div>

<SectionHeader number={6} title="Compliance (Quick Check)" />

          {/* Valid Medical License */}
          <div className="form-group">
            <label style={labelStyle}>Valid Medical License? <span style={{ color: '#e74c3c' }}>*</span></label>
            <RadioGroup options={['Yes', 'No']} selected={q.validLicense} onChange={v => setField('validLicense', v)} />
            {errors.validLicense && <span className="error-message" style={{ marginTop: '6px', display: 'block' }}>{errors.validLicense}</span>}
          </div>

          {/* License Type */}
          <div className="form-group">
            <label style={labelStyle}>
              License Type <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af' }}>(select if applicable)</span>
            </label>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '6px' }}>
              {[
                { val: 'DEA',     label: '🏥 DEA License',     id: 1 },
                { val: 'Medical', label: '📋 Medical License',  id: 2 },
              ].map(opt => {
                const active = q.licenseType === opt.val;
                return (
                  <label key={opt.val}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '9px 18px', borderRadius: '8px', border: `1.5px solid ${active ? '#018d71' : '#e2e8f0'}`, backgroundColor: active ? '#f0fdf9' : '#fff', fontSize: '13px', fontWeight: active ? 600 : 400, color: active ? '#018d71' : '#4b5563', transition: 'all 0.15s', userSelect: 'none' }}>
                    <input type="radio" checked={active} onChange={() => setField('licenseType', active ? '' : opt.val)} style={{ display: 'none' }} />
                    <span style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${active ? '#018d71' : '#d1d5db'}`, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {active && <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#018d71' }} />}
                    </span>
                    {opt.label}
                  </label>
                );
              })}
            </div>
          </div>

          {/* License details — shown only when a license type is selected */}
          {q.licenseType && (
            <div style={{ padding: '16px 20px', backgroundColor: '#f8fafc', borderRadius: '10px', border: '1.5px solid #e2e8f0', marginBottom: '8px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ fontSize: '13px', fontWeight: 700, color: '#374151', marginBottom: '2px' }}>
                {q.licenseType === 'DEA' ? '🏥 DEA License Details' : '📋 Medical License Details'}
              </div>

              {/* License Number */}
              <div>
                <label style={labelStyle}>
                  {q.licenseType === 'DEA' ? 'DEA Number' : 'Medical License Number'}
                  <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af', marginLeft: 6 }}>(optional)</span>
                </label>
                <input
                  style={fieldStyle}
                  placeholder={q.licenseType === 'DEA' ? 'e.g. AB1234567' : 'e.g. ML-0098765'}
                  value={q.licenseNumber}
                  onChange={e => setField('licenseNumber', e.target.value)}
                  onFocus={inputFocus}
                  onBlur={inputBlur}
                />
              </div>

              {/* Expiry Date */}
              <div>
                <label style={labelStyle}>
                  Expiry Date
                  <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af', marginLeft: 6 }}>(optional)</span>
                </label>
                <input
                  type="date"
                  style={fieldStyle}
                  min={new Date().toISOString().split('T')[0]}
                  value={q.licenseExpiryDate}
                  onChange={e => setField('licenseExpiryDate', e.target.value)}
                  onFocus={inputFocus}
                  onBlur={inputBlur}
                />
              </div>

              {/* Authorized Sign */}
              <div>
                <label style={labelStyle}>
                  Authorized Signatory Name
                  <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af', marginLeft: 6 }}>(optional)</span>
                </label>
                <input
                  style={fieldStyle}
                  placeholder="Full name of authorized signatory"
                  value={q.authorizedSign}
                  onChange={e => setField('authorizedSign', e.target.value)}
                  onFocus={inputFocus}
                  onBlur={inputBlur}
                />
              </div>
            </div>
          )}

          <SectionHeader number={7} title="Final" />
          <div className="form-group">
            <label style={labelStyle}>Preferred Order Method <span style={{ color: '#e74c3c' }}>*</span> <span style={{ fontSize: '12px', fontWeight: 400, color: '#9ca3af' }}>(select all that apply)</span></label>
            <CheckboxGroup options={['Email', 'Phone', 'Online']} selected={q.orderMethods} onChange={v => toggleCheckbox('orderMethods', v)} />
            {errors.orderMethods && <span className="error-message" style={{ marginTop: '6px', display: 'block' }}>{errors.orderMethods}</span>}
          </div>
          <div className="form-group">
            <label style={labelStyle}>Notes / Special Requests</label>
            <textarea style={{ ...fieldStyle, resize: 'vertical', minHeight: '90px' }} placeholder="Any additional notes or special requirements..." value={q.notes} onChange={e => setField('notes', e.target.value)} onFocus={inputFocus} onBlur={inputBlur} />
          </div>

          <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 20px' }}>
            <span style={{ color: '#e74c3c' }}>*</span> Required fields
          </p>
          <button onClick={handleSubmit} className="login-button" disabled={submitting} style={{ width: '100%' }}>
            {submitting ? 'Submitting...' : 'Submit & Continue to Login →'}
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Register Page ────────────────────────────────────────────────────────────
const RegisterPage = ({ onNavigate }) => {
  const [formData, setFormData] = useState({ fullName: '', gender: '', phoneNumber: '', email: '' });
  const [errors, setErrors]     = useState({});
  const [loading, setLoading]   = useState(false);
const [showQuestionnaire, setShowQuestionnaire] = useState(false);
const [registeredEmail, setRegisteredEmail]     = useState('');
const [registeredUserId, setRegisteredUserId]   = useState(null);   // ← ADD

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    else if (formData.fullName.length < 2) newErrors.fullName = 'Name must be at least 2 characters';
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!formData.phoneNumber.trim()) newErrors.phoneNumber = 'Phone number is required';
    else { const r = validatePhoneNumber(formData.phoneNumber.trim()); if (!r.valid) newErrors.phoneNumber = r.message; }
    if (!formData.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    return newErrors;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const newErrors = validateForm();
  if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }
  setLoading(true);
  try {
    // ── Pre-check duplicate email ────────────────────────────────────
    try {
      const allUsers = await apiService.get('/User/GetAll');
      let usersArray = [];
      if (Array.isArray(allUsers)) usersArray = allUsers;
      else if (Array.isArray(allUsers?.data)) usersArray = allUsers.data;
      else if (Array.isArray(allUsers?.users)) usersArray = allUsers.users;
      const emailExists = usersArray.some(u => u.email?.toLowerCase().trim() === formData.email?.toLowerCase().trim());
      if (emailExists) {
        setErrors({ email: 'This email address is already registered. Please use a different email or login to your existing account.' });
        setLoading(false);
        return;
      }
    } catch (checkErr) {
      console.warn('⚠️ Could not pre-check email, proceeding:', checkErr.message);
    }

    // ── Register user ────────────────────────────────────────────────
    await apiService.registerUser(formData);

    // ── Extract userId and store in localStorage ─────────────────────
    let registeredUserId = null;
    try {
      const allUsers = await apiService.get('/User/GetAll');
      let usersArray = [];
      if (Array.isArray(allUsers)) usersArray = allUsers;
      else if (Array.isArray(allUsers?.data)) usersArray = allUsers.data;
      else if (Array.isArray(allUsers?.users)) usersArray = allUsers.users;

      const matched = usersArray.find(
        u => u.email?.toLowerCase().trim() === formData.email?.toLowerCase().trim()
      );
      if (matched) {
        const rawId = matched.id ?? matched.userId ?? matched.ID ?? matched.Id;
        const parsed = parseInt(rawId, 10);
        if (!isNaN(parsed) && parsed > 0) {
          registeredUserId = parsed;
          // ✅ Store so createAddress / createClinic can read it
          localStorage.setItem('userId', String(registeredUserId));
          console.log('✅ Stored userId in localStorage after registration:', registeredUserId);
        }
      }
    } catch (lookupErr) {
      console.warn('⚠️ Could not fetch userId after registration:', lookupErr.message);
    }

    setRegisteredEmail(formData.email);
    setRegisteredUserId(registeredUserId);   // ← pass to questionnaire
    setShowQuestionnaire(true);

  } catch (error) {
    const status = error.response?.status;
    const allText = JSON.stringify(error.response?.data || error.message || '').toLowerCase();
    const looksLikeDuplicate = status === 400 || status === 409 || status === 422
      || allText.includes('email') || allText.includes('exist')
      || allText.includes('duplicate') || allText.includes('taken');
    if (looksLikeDuplicate)
      setErrors({ email: 'This email address is already registered. Please use a different email or login to your existing account.' });
    else if (error.request && !error.response)
      setErrors({ submit: 'Network error. Please check your connection.' });
    else
      setErrors({ submit: 'Something went wrong. Please try again.' });
  } finally {
    setLoading(false);
  }
};

  if (showQuestionnaire) return (
  <QuestionnaireForm
    registeredEmail={registeredEmail}
    registeredUserId={registeredUserId}
    onDone={() => onNavigate('login')}
  />
);
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header"><h1>Create Account</h1><p>Sign up to get started</p></div>
          <form onSubmit={handleSubmit} className="login-form">
            {errors.submit && <div className="error-message" style={{ marginBottom: '15px', textAlign: 'center', color: '#e74c3c' }}>{errors.submit}</div>}
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className={`form-control ${errors.fullName ? 'error' : ''}`} placeholder="Enter your full name" />
              {errors.fullName && <span className="error-message">{errors.fullName}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <select id="gender" name="gender" value={formData.gender} onChange={handleChange} className={`form-control ${errors.gender ? 'error' : ''}`}>
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
                <option value="prefer-not-to-say">Prefer not to say</option>
              </select>
              {errors.gender && <span className="error-message">{errors.gender}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <SmartPhoneInput value={formData.phoneNumber} onChange={handleChange}
                onBlur={() => { if (formData.phoneNumber.trim()) { const result = validatePhoneNumber(formData.phoneNumber.trim()); if (!result.valid) setErrors(prev => ({ ...prev, phoneNumber: result.message })); else setErrors(prev => ({ ...prev, phoneNumber: '' })); } }}
                error={errors.phoneNumber} name="phoneNumber" />
              {errors.phoneNumber && <span className="error-message" style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>⚠️ {errors.phoneNumber}</span>}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className={`form-control ${errors.email ? 'error' : ''}`} placeholder="Enter your email" style={errors.email ? { borderColor: '#e74c3c' } : {}} />
              {errors.email && (
                <div style={{ marginTop: '6px', padding: '10px 12px', backgroundColor: '#fff5f5', border: '1px solid #fca5a5', borderRadius: '6px', fontSize: '13px', color: '#dc2626', fontWeight: 500, display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <span style={{ fontSize: '15px', flexShrink: 0 }}>⚠️</span>
                  <span>
                    {errors.email}
                    {errors.email.includes('already registered') && (
                      <> <button type="button" onClick={() => onNavigate('login')} style={{ background: 'none', border: 'none', padding: 0, color: '#018d71', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline', fontSize: '13px' }}>Login instead?</button></>
                    )}
                  </span>
                </div>
              )}
            </div>
            <button type="submit" className="login-button" disabled={loading}>{loading ? 'Creating Account...' : 'Create Account'}</button>
          </form>
          <div className="login-footer">
            <p>Already have an account?{' '}<button type="button" className="register-link" onClick={() => onNavigate('login')}>Login here</button></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;